import invert from './invert.js';
import escapeMap from './_escapeMap.js';

// Internal list of HTML entities for unescaping.
export default invert(escapeMap);



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/_unescapeMap.js
// module id = 466
// module chunks = 8